import * as SubNav from './index';
import { useFetchPayoutAccount } from 'assets/js/pages/payouts/useFetchPayoutAccount';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const PayoutsSubNavTabs = () => {
    const { accountId, formerStripeAccount } = useCurrentAccount();
    const { data: payoutAccount } = useFetchPayoutAccount();
    const payoutAccountData = payoutAccount.data;
    const showSettings =
        payoutAccountData?.merchant_onboarding_complete &&
        payoutAccountData?.merchant_account_type === 'custom';

    return (
        <SubNav.Tabs>
            <SubNav.TabItem to={`/accounts/${accountId}/payouts`} exact>
                All
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/payouts/balance`}
                data-testid={TestIds.Payouts.HasBalance}
            >
                Has balance
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/payouts/withdrawn`}
                data-testid={TestIds.Payouts.Withdrawn}
            >
                Withdrawn
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/payouts/history`}
                data-testid={TestIds.Payouts.History}
            >
                Payout history
            </SubNav.TabItem>
            {formerStripeAccount && (
                <SubNav.TabItem
                    to={`/accounts/${accountId}/payouts/documents`}
                    data-testid={TestIds.Payouts.TaxDocuments}
                >
                    Tax documents
                </SubNav.TabItem>
            )}
            {showSettings && (
                <SubNav.TabItem
                    to={`/accounts/${accountId}/payouts/settings`}
                    data-testid={TestIds.Payouts.PayoutSettings}
                    data-intercom-target={IntercomProductTourTargets.PayoutsSettingsSubnav}
                >
                    Settings
                </SubNav.TabItem>
            )}
        </SubNav.Tabs>
    );
};
export { PayoutsSubNavTabs };
